module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kaigyo-1c1637c8cab70fd2e411c70ec848372c.png";